__turbopack_context__.v({
  "action": "SectionHeader-module__pq5_Bq__action",
  "after": "SectionHeader-module__pq5_Bq__after",
  "aside": "SectionHeader-module__pq5_Bq__aside",
  "badge": "SectionHeader-module__pq5_Bq__badge",
  "header": "SectionHeader-module__pq5_Bq__header",
  "headline": "SectionHeader-module__pq5_Bq__headline",
  "intro": "SectionHeader-module__pq5_Bq__intro",
  "introLead": "SectionHeader-module__pq5_Bq__introLead",
  "texts": "SectionHeader-module__pq5_Bq__texts",
  "title": "SectionHeader-module__pq5_Bq__title",
});
